export const AI_BUILDING_COPY = {
  title: 'Our AI agent is building your store',
  subtitle: {
    ecommerce: 'Importing your products and images',
    catering: 'Plating your menu',
    both: 'Importing your products and menu'
  }
}

export function aiBuildingCopy(platforms) {
  const active = Array.isArray(platforms) ? platforms : []
  const catering = active.includes('catering')
  const ecommerce = active.includes('ecommerce')
  const subtitles = AI_BUILDING_COPY.subtitle

  let subtitle = subtitles.ecommerce
  if (catering && ecommerce) subtitle = subtitles.both
  else if (catering) subtitle = subtitles.catering

  return { title: AI_BUILDING_COPY.title, subtitle }
}
